import {DeploymentAccountGroup,} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";
import {Stack, Table, Title} from '@mantine/core';


export const Profile = ({record}: { record: DeploymentAccountGroup }) => {

    const properties = [
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>

            {record.accounts && record.accounts.length > 0 && (
                <Stack gap={'sm'}>
                    <Title order={5}>Accounts</Title>
                    <Table striped highlightOnHover withTableBorder>
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th>Account ID</Table.Th>
                                <Table.Th>Account Name</Table.Th>
                                <Table.Th>Region</Table.Th>
                                <Table.Th>Environment</Table.Th>
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {record.accounts.map((account, index) => (
                                <Table.Tr key={index}>
                                    <Table.Td>{account.accountId}</Table.Td>
                                    <Table.Td>{account.accountName}</Table.Td>
                                    <Table.Td>{account.region}</Table.Td>
                                    <Table.Td>{account.environment}</Table.Td>
                                </Table.Tr>
                            ))}
                        </Table.Tbody>
                    </Table>
                </Stack>
            )}
        </Stack>
    );


};
